<ng-container [appPreloader]="[endpoints.LOANS_PAYOUT_POST, endpoints.LOANS_PAYOUT_PUT]"
              [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<div mat-dialog-title>
  <div
    class="dialog-caption">{{data.loanPayoutType === payoutTypes.REFINANCE ? 'Refinance Details' : 'Payout Details'}}</div>
  <div class="dialog-subtitle">{{ data.bankAccount.accountName }} No. {{ data.bankAccount.accountNumber }}</div>
  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content>
  <div class="main-content">
    <app-loan-payout-form
      #payoutForm
      [loan]="data.loan"
      [taxTankBalance]="data.taxTankBalance"
      (submitted)="submit($event)">
    </app-loan-payout-form>
  </div>
</div>

<div mat-dialog-actions>
  <div class="row gx-3 align-h-right">
    <div class="col-6 col-sm-auto">
      <button mat-dialog-close class="btn basic w-100">Cancel</button>
    </div>
    <div class="col-6 col-sm-auto">
      <button type="submit" class="btn primary w-100" (click)="payoutForm.submit()">Apply</button>
    </div>
  </div>
</div>
